import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { getSession } from '../auth/session';

interface ProtectedRouteProps {
  children: ReactNode;
  allow: Array<'admin' | 'user' | 'super'>;
}

function normalizeRole(role: string): 'admin' | 'user' | 'super' | 'unknown' {
  if (role === 'admin' || role === 'super') return role;
  if (role === 'user' || role === 'student' || role === 'professor') return 'user';
  return 'unknown';
}

export default function ProtectedRoute({ children, allow }: ProtectedRouteProps) {
  const session = getSession();

  if (!session) {
    const loginPath = allow.includes('super') ? '/super/login' : allow.includes('admin') ? '/admin/login' : '/';
    return <Navigate to={loginPath} replace />;
  }

  const role = normalizeRole(session.role);
  const allowed = role !== 'unknown' && allow.includes(role);

  if (!allowed) {
    if (role === 'super') return <Navigate to="/super/dashboard" replace />;
    if (role === 'admin') return <Navigate to="/admin/dashboard" replace />;
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
